import PropTypes from 'prop-types';
import React from 'react';

const ListViewWrapper = ({ title, buttons, children }) => (
  <div className="container">
    <div className='row'>
      <div className='col-12 d-flex align-items-baseline'>
        <div className='flex-grow-1'>
          <h3 className='page-title'>{title}</h3>
        </div>
        <div className='flex-grow-0 text-end'>{buttons}</div>
      </div>
      <div className='col-12'>
        {children}
      </div>
    </div>
  </div>
);

ListViewWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  buttons: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]),
  children: PropTypes.node.isRequired,
};

export { ListViewWrapper };
